import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";
import styles from "./Input.module.css";
import { clx } from "../../utilities/clx";
type InputProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;
export const Input: React.FC<
  {
    iconBefore?: React.ReactNode;
    iconAfter?: React.ReactNode;
  } & InputProps
> = ({ iconBefore, iconAfter, ...props }) => {
  return (
    <div className={styles.InputContainer}>
      {iconBefore && (
        <div className={clx([styles.Icon, styles.IconBefore])}>
          {iconBefore}
        </div>
      )}
      <input
        className={styles.Input}
        {...props}
        style={{
          paddingLeft: iconBefore ? "3em" : undefined,
          paddingRight: iconAfter ? "3em" : undefined,
        }}
      />
      {iconAfter && (
        <div className={clx([styles.Icon, styles.IconAfter])}>{iconAfter}</div>
      )}
    </div>
  );
};
